import React, { useEffect, useState } from "react";
import { format, parse, isValid } from "date-fns";
import { enGB } from "date-fns/locale";
import { CalendarDays, X } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Calendar } from "../ui/calendar";
import { Input } from "../ui/input";

const toIso = (d) => format(d, "yyyy-MM-dd");
const fromIso = (s) => (s ? parse(s.slice(0, 10), "yyyy-MM-dd", new Date()) : null);
const show = (s) => (s ? format(fromIso(s), "dd/MM/yyyy") : "");

// UK date field: type dd/mm/yyyy or pick from the calendar; emits ISO yyyy-mm-dd (or null).
export const UkDateInput = ({ value, onChange, disabled, testId }) => {
  const [text, setText] = useState(show(value));
  const [open, setOpen] = useState(false);
  const [bad, setBad] = useState(false);
  useEffect(() => { setText(show(value)); setBad(false); }, [value]);
  const commit = () => {
    if (!text.trim()) { setBad(false); return onChange(null); }
    const d = parse(text.trim(), "d/M/yyyy", new Date());
    if (isValid(d) && d.getFullYear() > 1900) { setBad(false); onChange(toIso(d)); } else setBad(true);
  };
  return (
    <div className="flex items-center gap-1">
      <Input value={text} placeholder="dd/mm/yyyy" disabled={disabled} onChange={(e) => setText(e.target.value)} onBlur={commit}
        onKeyDown={(e) => e.key === "Enter" && commit()} className={`rounded-none ${bad ? "border-red-500" : ""}`} data-testid={testId} />
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button type="button" disabled={disabled} className="h-9 w-9 shrink-0 border flex items-center justify-center hover:bg-slate-50 disabled:opacity-50"
            style={{ borderColor: "var(--hi-border)" }} data-testid={testId && `${testId}-calendar`}><CalendarDays className="h-4 w-4" /></button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0 rounded-none" align="start">
          <Calendar mode="single" locale={enGB} weekStartsOn={1} selected={fromIso(value) || undefined}
            defaultMonth={fromIso(value) || undefined} onSelect={(d) => { if (d) onChange(toIso(d)); setOpen(false); }} initialFocus />
        </PopoverContent>
      </Popover>
      {value && !disabled && (
        <button type="button" onClick={() => onChange(null)} className="h-9 w-7 shrink-0 text-muted-foreground hover:text-red-700" title="Clear date"
          data-testid={testId && `${testId}-clear`}><X className="h-3.5 w-3.5" /></button>
      )}
      {bad && <span className="text-[10px] text-red-600 whitespace-nowrap">Use dd/mm/yyyy</span>}
    </div>
  );
};
